module.exports = "<areas-list></areas-list>\r\n\r\n<areas-edit></areas-edit>\r\n<areas-add></areas-add>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/pages/areas/areas.component.html
// module id = ../../../../../src/app/pages/areas/areas.component.html
// module chunks = main